/**
 * The id a session's card carries on /instruiri, which a search hit for it names after the `#`
 * (`/instruiri#sesiune-{sessionId}`, the url the backend indexes). One place for the prefix, so
 * the card and anything that links to it cannot drift apart.
 */
export function trainingSessionAnchor(sessionId: string): string {
  return `sesiune-${sessionId}`;
}
